export function logoutAndRedirect(target: string = '/login') {
  const url = new URL(target, window.location.origin);
  url.searchParams.set('logout', '1');
  window.location.replace(url.pathname + url.search + url.hash);
}
